var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',_vm._b({attrs:{"to":_vm.to}},'router-link',{ ..._vm.$props, ..._vm.$attrs },false),[_vm._t("default"),_vm._v(" "),_c('v-icon',{attrs:{"color":"secondary","small":""}},[_vm._v("fa-light fa-arrow-right")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }